<template>
  <div>
    <v-subheader class="sn-subtitle-2 sn-table-filter-subheader">
      SORT
    </v-subheader>
    <v-list-item-group>
      <v-list-item
        v-for="sort in sortByOptions"
        :key="sort.value"
        :value="sort.value"
        :ripple="false"
        :data-cy="`sort-option-${sort.text}`"
        @click="changeSelection(sort.value)"
      >
        <v-list-item-action class="mr-3">
          <v-icon :color="sort.value === selection ? 'snBrand03' : 'snPrimary03'">
            {{ sort.value === selection ? '$snRadioSelected' : '$snRadio' }}
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title class="sn-body-1">
            {{ sort.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </div>
</template>

<script>
export default {
  name: 'SortOptions',
  props: {
    sortByOptions: {
      type: Array,
      required: true
    },
    activeSort: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selection: null
    }
  },
  watch: {
    activeSort (sortBy) {
      const sortedByAnotherColumn = !this.sortByOptions.map(o => o.value).includes(sortBy)

      if (sortedByAnotherColumn) {
        this.selection = null
      }
    }
  },
  mounted () {
    if (this.activeSort) {
      this.changeSelection(this.activeSort)
    }
  },
  methods: {
    changeSelection (selection) {
      this.selection = selection
      this.$emit('change', selection)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-list-item.v-list-item--active {
  color: #fff;
}
</style>
